/**
 * ファイルをBase64エンコードする
 */
export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

/**
 * ファイルが画像かどうかを判定
 */
export const isImageFile = (file: File): boolean => {
  return file.type.startsWith('image/');
};

/**
 * ファイルサイズを人間が読める形式にフォーマット
 */
export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

/**
 * ファイル情報を拡張形式に変換（Base64データ付き）
 */
export const processFileForUpload = async (file: File) => {
  const base64Data = isImageFile(file) ? await fileToBase64(file) : undefined;
  
  return {
    id: `${Date.now()}_${Math.random()}`,
    fileName: file.name,
    fileSize: file.size,
    fileType: file.type,
    base64Data, // 画像の場合のみBase64データを含める
  };
};

/**
 * 複数ファイルを並行処理でBase64エンコード
 */
export const processFilesForUpload = async (files: File[]) => {
  return Promise.all(files.map(processFileForUpload));
}; 